export const PROJECT_DISCUSSION_COMMENT_CONTENT_TYPE_COMMENT = 'COMMENT';
export const PROJECT_DISCUSSION_COMMENT_CONTENT_TYPE_NEED_MORE_INFO = 'NEED_MORE_INFO';
